import { render, staticRenderFns } from "./ChartSetting.vue?vue&type=template&id=3d953b3c"
import script from "./ChartSetting.vue?vue&type=script&lang=js"
export * from "./ChartSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports